import SubscriptionPaymentSuccessModal from './SubscriptionPaymentSuccessModal'

export default SubscriptionPaymentSuccessModal
